import {
  keepPreviousData,
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastError, toastExito } from "@/lib/toast";
import { extractApiMessage } from "@/shared/api/extract-message";
import {
  obtenerCalendarioDePagos,
  obtenerOrganizacionesDelCalendario,
  reprogramarFechaPago,
  type CalendarioParams,
} from "../services/calendario-pagos.api";

export const calendarioPagosQueryOptions = (params: CalendarioParams = {}) =>
  queryOptions({
    queryKey: qk.calendarioPagos(params),
    queryFn: () => obtenerCalendarioDePagos(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });

export function useCalendarioPagos(params: CalendarioParams) {
  return useQuery(calendarioPagosQueryOptions(params));
}

/** Hotspot 93 · sociedades del combo de filtro del calendario. */
export function useOrganizacionesDelCalendario() {
  return useQuery({
    queryKey: qk.calendarioPagosOrganizaciones,
    queryFn: obtenerOrganizacionesDelCalendario,
    staleTime: 5 * 60_000,
  });
}

export function useReprogramarFechaPago() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: reprogramarFechaPago,
    onSuccess: (_, args) => {
      void qc.invalidateQueries({ queryKey: ["calendario-pagos"] });
      toastExito({ title: "Fecha de pago reprogramada", message: `Nueva fecha: ${args.nuevaFecha}` });
    },
    onError: (error: unknown) => {
      toastError({ title: "No se pudo reprogramar", message: extractApiMessage(error, "Intenta de nuevo.") });
    },
  });
}
